
import { ButtonContent } from "../global/boton/ButtonContent";

// import { TbPlant2 } from "react-icons/tb";

function HeroSection({ bgImg, bgImg1, bgImg2, bgImg3, title, texts }) {

  const BgImages = [
    bgImg,
    bgImg1,
    bgImg2,
    bgImg3,
  ]
  return (
    <>
      <div className="pic-wrapper svgHerosection1  w-full h-screen" >
        {
          BgImages.map((item, index) => {
            return (
              <figure
                key={index}
                className={`pic-${index + 1}`}
                style={{ background: `url("${item}")` }}
              ></figure>
            )
          })
        }
        <div className="z-10 relative w-4/5 mx-auto h-full grid md:grid-cols-2 grid-cols-1 items-center md:pb-[100px] md:pt-[250px] pt-[250px] pb-[50px]">


          <div>
            <div className="w-full flex flex-col justify-center items-center">
              <h1 className="text-white text-center text-[35px] md:text-[60px]">
                {title}
              </h1>
              <p className="text-white text-center">
                {texts}
              </p>
            </div>
            <div className="w-full flex justify-center py-5">
              <ButtonContent btnStyle={'three'} />
            </div>
          </div>

          <div className="flex justify-center md:-mt-20 mt-5">
            <img src="https://firebasestorage.googleapis.com/v0/b/imagenes-fc412.appspot.com/o/Años%20de%20experiencia%2F23%20Years.png?alt=media&token=45b9a080-a59b-425a-88f6-3c04e239512b&_gl=1*12gmr4j*_ga*MTEwNjA2NzQ4Mi4xNjcxODIyMzAz*_ga_CW55HF8NVT*MTY4NTU1MzExNC40LjAuMTY4NTU1MzExNC4wLjAuMA.." 
            alt="years exp" 
            className="md:w-[300px] md:h-[300px] w-[200px]" />
          </div>

        </div>
      </div>

    </>
  );
}

export default HeroSection;
